import React, { PropsWithChildren } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import TextField from '@mui/material/TextField';

import { black08, copper, darkGrey, sizeMobile, sizeTabletLg } from '~/styles';

export const Wrapper = styled.div`
  position: relative;
  min-height: 40px;
  padding: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-flow: row nowrap;
  flex-flow: row nowrap;
  max-width: 500px;

  ${sizeTabletLg(css`
    max-height: 500px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: none !important;
    padding: 0 16px;
    max-width: inherit;
    form {
      margin-right: auto;
      margin-left: auto;
    }
  `)} ${sizeMobile(css`
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
  `)};
`;

export const InputWrapper = styled.div<{ horizontal?: boolean }>`
  ${props => !props.horizontal && `margin-bottom: 1rem;`};
  ${props => props.horizontal && `padding-right: 10px;`};
  width: 100%;
  align-self: center;
`;

export const Input = styled(TextField)<{ filledDark?: boolean }>`
  width: 100%;
  border-radius: 1px;
  margin-bottom: 7px;
  margin-top: 7px;

  .Mui-focused {
    font-weight: 500;
    color: ${copper};
  }

  .MuiInputBase-input:focus {
    font-weight: 500;
    color: ${darkGrey};
  }

  .MuiFilledInput-underline:after {
    border-bottom: 2px solid ${copper};
  }
  .MuiFilledInput-underline:before {
    border-bottom: none;
  }
  .MuiFilledInput-root {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  .MuiInputBase-formControl {
    background-color: white;
    ${({ filledDark }) =>
      filledDark &&
      css`
        background-color: ${black08};
      `}
  }
` as React.FC<PropsWithChildren<{ filledDark?: boolean } & React.ComponentProps<typeof TextField>>>;
